/* eslint-disable */
import axios from "axios";
import "../utils/axios.interceptor";
import { format } from "date-fns";
import { urlCoreBack } from "../../project/configs/config";

const epNameCajaCerrar = "v1/caja-cerrar/";
const epNameCajaRevisar = "v1/caja-revision/";
const epNameSalirCajaRevisar = "v1/caja-salir-revision/";
const epNameCaja = "v1/caja/";
const nameItemsTextCaja = "Caja";
const nameItemTextCaja = "Caja";
const epNameCajaAjuste = "v1/caja_ajuste/";
const epNameCajaComprobante = "v1/caja_comprobante/";
const nameItemsTextCajaMovimiento = "Caja Movimientos";
const nameItemTextCajaMovimiento = "Movimiento de Caja";

const itemGender = "F";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//
export const getCajas = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener Cajas";

  // limpio los parametros de busqueda segun corresponda al tipo de cobro seleccionado

  switch (params.tipoCobro) {
    case "efectivo":
      params.tarjetaDebito = "";
      params.numeroCuponTarjetaDebito = "";
      params.numeroLoteTarjetaDebito = "";
      params.tarjetaCredito = "";
      params.numeroCuponTarjetaCredito = "";
      params.numeroLoteTarjetaCredito = "";
      params.billetera = "";
      params.obraSocial = "";
      params.obraSocialPlan = "";
      params.numeroBeneficiario = "";
      params.numeroAutorizacion = "";
      params.descripcionDescuentoEspecial = "";
      params.descripcionOtraFormadeCobro = "";
      params.cuentaBancaria = "";
      params.numeroComprobante = "";
      params.banco = "";
      params.numeroCheque = "";
      break;

    case "tarjeta-debito":
      params.tarjetaCredito = "";
      params.numeroCuponTarjetaCredito = "";
      params.numeroLoteTarjetaCredito = "";
      params.billetera = "";
      params.obraSocial = "";
      params.obraSocialPlan = "";
      params.numeroBeneficiario = "";
      params.numeroAutorizacion = "";
      params.descripcionDescuentoEspecial = "";
      params.descripcionOtraFormadeCobro = "";
      params.cuentaBancaria = "";
      params.numeroComprobante = "";
      params.banco = "";
      params.numeroCheque = "";
      break;

    case "tarjeta-credito":
      params.tarjetaDebito = "";
      params.numeroCuponTarjetaDebito = "";
      params.numeroLoteTarjetaDebito = "";
      params.billetera = "";
      params.obraSocial = "";
      params.obraSocialPlan = "";
      params.numeroBeneficiario = "";
      params.numeroAutorizacion = "";
      params.descripcionDescuentoEspecial = "";
      params.descripcionOtraFormadeCobro = "";
      params.cuentaBancaria = "";
      params.numeroComprobante = "";
      params.banco = "";
      params.numeroCheque = "";
      break;

    case "billetera-virtual":
      params.tarjetaDebito = "";
      params.numeroCuponTarjetaDebito = "";
      params.numeroLoteTarjetaDebito = "";
      params.tarjetaCredito = "";
      params.numeroCuponTarjetaCredito = "";
      params.numeroLoteTarjetaCredito = "";
      params.obraSocial = "";
      params.obraSocialPlan = "";
      params.numeroBeneficiario = "";
      params.numeroAutorizacion = "";
      params.descripcionDescuentoEspecial = "";
      params.descripcionOtraFormadeCobro = "";
      params.cuentaBancaria = "";
      params.numeroComprobante = "";
      params.banco = "";
      params.numeroCheque = "";
      break;

    case "obra-social":
      params.tarjetaDebito = "";
      params.numeroCuponTarjetaDebito = "";
      params.numeroLoteTarjetaDebito = "";
      params.tarjetaCredito = "";
      params.numeroCuponTarjetaCredito = "";
      params.numeroLoteTarjetaCredito = "";
      params.billetera = "";
      params.descripcionDescuentoEspecial = "";
      params.descripcionOtraFormadeCobro = "";
      params.cuentaBancaria = "";
      params.numeroComprobante = "";
      params.banco = "";
      params.numeroCheque = "";
      break;

    case "descuento-especial":
      params.tarjetaDebito = "";
      params.numeroCuponTarjetaDebito = "";
      params.numeroLoteTarjetaDebito = "";
      params.tarjetaCredito = "";
      params.numeroCuponTarjetaCredito = "";
      params.numeroLoteTarjetaCredito = "";
      params.billetera = "";
      params.obraSocial = "";
      params.obraSocialPlan = "";
      params.numeroBeneficiario = "";
      params.numeroAutorizacion = "";
      params.descripcionOtraFormadeCobro = "";
      params.cuentaBancaria = "";
      params.numeroComprobante = "";
      params.banco = "";
      params.numeroCheque = "";
      break;

    case "otro":
      params.tarjetaDebito = "";
      params.numeroCuponTarjetaDebito = "";
      params.numeroLoteTarjetaDebito = "";
      params.tarjetaCredito = "";
      params.numeroCuponTarjetaCredito = "";
      params.numeroLoteTarjetaCredito = "";
      params.billetera = "";
      params.obraSocial = "";
      params.obraSocialPlan = "";
      params.numeroBeneficiario = "";
      params.numeroAutorizacion = "";
      params.descripcionDescuentoEspecial = "";
      params.cuentaBancaria = "";
      params.numeroComprobante = "";
      params.banco = "";
      params.numeroCheque = "";
      break;

    case "transferencia-bancaria":
      params.tarjetaDebito = "";
      params.numeroCuponTarjetaDebito = "";
      params.numeroLoteTarjetaDebito = "";
      params.tarjetaCredito = "";
      params.numeroCuponTarjetaCredito = "";
      params.numeroLoteTarjetaCredito = "";
      params.billetera = "";
      params.obraSocial = "";
      params.obraSocialPlan = "";
      params.numeroBeneficiario = "";
      params.numeroAutorizacion = "";
      params.descripcionDescuentoEspecial = "";
      params.descripcionOtraFormadeCobro = "";
      params.banco = "";
      params.numeroCheque = "";
      break;

    case "cheque":
      params.tarjetaDebito = "";
      params.numeroCuponTarjetaDebito = "";
      params.numeroLoteTarjetaDebito = "";
      params.tarjetaCredito = "";
      params.numeroCuponTarjetaCredito = "";
      params.numeroLoteTarjetaCredito = "";
      params.billetera = "";
      params.obraSocial = "";
      params.obraSocialPlan = "";
      params.numeroBeneficiario = "";
      params.numeroAutorizacion = "";
      params.descripcionDescuentoEspecial = "";
      params.descripcionOtraFormadeCobro = "";
      params.cuentaBancaria = "";
      break;
  }

  if (params.codigoCaja) {
    _params.caja_codigo = params.codigoCaja;
  }

  if (params.fechaCreacionDesde) {
    _params.fecha_creacion_desde = format(params.fechaCreacionDesde, "yyyy/MM/dd");
  }

  if (params.fechaCreacionHasta) {
    _params.fecha_creacion_hasta = format(params.fechaCreacionHasta, "yyyy/MM/dd");
  }

  if (params.estadoActual) {
    _params.estado_actual = params.estadoActual;
  }

  if (params.usuario) {
    _params.id_usuario = params.usuario;
  }

  _params.id_area = localStorage.getItem("id_area_ventas");

  if (params.codigoGA) {
    _params.gc_codigo = params.codigoGA;
  }

  if (params.nombre) {
    _params.cliente_nombre = params.nombre;
  }

  if (params.apellido) {
    _params.cliente_apellido = params.apellido;
  }

  if (params.clienteId) {
    _params.id_cliente = params.clienteId;
  }

  if (params.tipoCobro) {
    _params.tipo_cobro = params.tipoCobro;
  }

  if (params.tarjetaDebito) {
    _params.id_tarjeta_banco_acuerdo = params.tarjetaDebito;
  }

  if (params.numeroCuponTarjetaDebito) {
    _params.numero_cupon_tarjeta = params.numeroCuponTarjetaDebito;
  }

  if (params.numeroLoteTarjetaDebito) {
    _params.numero_lote_tarjeta = params.numeroLoteTarjetaDebito;
  }

  if (params.tarjetaCredito) {
    _params.id_tarjeta_banco_acuerdo = params.tarjetaCredito;
  }

  if (params.numeroCuponTarjetaCredito) {
    _params.numero_cupon_tarjeta = params.numeroCuponTarjetaCredito;
  }

  if (params.numeroLoteTarjetaCredito) {
    _params.numero_lote_tarjeta = params.numeroLoteTarjetaCredito;
  }

  if (params.billetera) {
    _params.id_billetera = params.billetera;
  }

  if (params.obraSocial) {
    _params.id_obra_social = params.obraSocial;
  }

  if (params.obraSocialPlan) {
    _params.id_obra_social_plan = params.obraSocialPlan;
  }

  if (params.numeroBeneficiario) {
    _params.numero_beneficiario_obra_social = params.numeroBeneficiario;
  }

  if (params.numeroAutorizacion) {
    _params.numero_autorizacion_obra_social = params.numeroAutorizacion;
  }

  if (params.descripcionDescuentoEspecial) {
    _params.descripcion = params.descripcionDescuentoEspecial;
  }

  if (params.descripcionOtraFormadeCobro) {
    _params.descripcion = params.descripcionOtraFormadeCobro;
  }

  if (params.cuentaBancaria) {
    _params.id_cuenta_bancaria = params.cuentaBancaria;
  }

  if (params.numeroComprobante) {
    _params.numero_comprobante_cuenta_bancaria = params.numeroComprobante;
  }

  if (params.banco) {
    _params.banco_cheque = params.banco;
  }

  if (params.numeroCheque) {
    _params.numero_cheque = params.numeroCheque;
  }

  if (params.tipoMovimiento) {
    _params.tipo_movimiento = params.tipoMovimiento;
  }

  if (params.tipoAjuste) {
    _params.id_tipo_ajuste = params.tipoAjuste;
  }

  if (params.descripcionAjuste) {
    _params.descripcion_ajuste = params.descripcionAjuste;
  }

  if (params.tipoComprobante) {
    _params.id_tipo_comprobante = params.tipoComprobante;
  }

  if (params.descripcionComprobante) {
    _params.descripcion_gasto = params.descripcionComprobante;
  }

  if (params.numeroComprobante) {
    _params.numero_comprobante = params.numeroComprobante;
  }

  if (params.proveedor) {
    _params.id_proveedor = params.proveedor;
  }

  if ("rows" in params) {
    _params.rows = params.rows;
  }

  if ("first" in params) {
    _params.first = params.first;
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epNameCaja}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado 
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    let _message_code = response.data.code;
    if (_message_code === "err-caja-mdc-os-plan-invalid") {
      response.messageText = `El Plan de Obra Social no es válido`;
    } else {
      response.messageText = _errorMessage;
    }
    response.ok = false;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};

//
// #############################################################################
//
export const getCaja = async (params) => {

  let _errorMessage = "Se produjo un error al obtener la Caja";
  let id_area = localStorage.getItem("id_area_ventas");
  let _params = {};

  if (params.idCaja) {
    _params.id = params.idCaja;
  }
  _params.tipo_movimiento = params.tipoMovimiento;


  if (params.idTipoAjuste) {
    _params.id_tipo_ajuste = params.idTipoAjuste
  }
  if (params.descripcionAjuste) {
    _params.descripcion_ajuste = params.descripcionAjuste
  }
  if (params.idTipoComprobante) {
    _params.id_tipo_comprobante = params.idTipoComprobante
  }
  if (params.descripcionComprobante) {
    _params.descripcion_gasto = params.descripcionComprobante
  }
  if (params.idProveedor) {
    _params.id_proveedor = params.idProveedor
  }
  if (params.numeroComprobante) {
    _params.numero_comprobante = params.numeroComprobante
  }
  if (params.tipoCobro) {
    _params.tipo_cobro = params.tipoCobro
  }
  if (params.tarjetaDebito) {
    _params.id_tarjeta_banco_acuerdo = params.tarjetaDebito
  }
  if (params.numeroCuponTarjetaDebito) {
    _params.numero_cupon_tarjeta = params.numeroCuponTarjetaDebito
  }
  if (params.numeroLoteTarjetaDebito) {
    _params.numero_lote_tarjeta = params.numeroLoteTarjetaDebito
  }
  if (params.tarjetaCredito) {
    _params.id_tarjeta_banco_acuerdo = params.tarjetaCredito
  }
  if (params.numeroCuponTarjetaCredito) {
    _params.numero_cupon_tarjeta = params.numeroCuponTarjetaCredito
  }
  if (params.numeroLoteTarjetaCredito) {
    _params.numero_lote_tarjeta = params.numeroLoteTarjetaCredito
  }
  if (params.billetera) {
    _params.id_billetera = params.billetera
  }
  if (params.obraSocial) {
    _params.id_obra_social = params.obraSocial
  }
  if (params.obraSocialPlan) {
    _params.id_obra_social_plan = params.obraSocialPlan
  }
  if (params.numeroBeneficiario) {
    _params.numero_beneficiario_obra_social = params.numeroBeneficiario
  }
  if (params.numeroAutorizacion) {
    _params.numero_autorizacion_obra_social = params.numeroAutorizacion
  }
  if (params.descripcionDescuentoEspecial) {
    _params.descripcion = params.descripcionDescuentoEspecial
  }
  if (params.descripcionOtraFormadeCobro) {
    _params.descripcion = params.descripcionOtraFormadeCobro
  }
  if (params.cuentaBancaria) {
    _params.id_cuenta_bancaria = params.cuentaBancaria
  }
  if (params.numeroComprobante) {
    _params.numero_comprobante_cuenta_bancaria = params.numeroComprobante
  }
  if (params.banco) {
    _params.banco_cheque = params.banco
  }
  if (params.numeroCheque) {
    _params.numero_cheque = params.numeroCheque
  }
  if (params.idCliente) {
    _params.id_cliente = params.idCliente
  }

  if ("rows" in params) {
    _params.rows = params.rows;
  }
  if ("first" in params) {
    _params.first = params.first;
  }
  _params.id_area = id_area;

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epNameCaja}`,
      params: _params
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const saveCaja = async (actionCrud, Caja) => {
  let _errorMessage = `No fue posible guardar ${elLa} ${nameItemTextCaja}`;

  Caja.id_area = localStorage.getItem("id_area_ventas");
  Caja.id_usuario = localStorage.getItem("id_usuario");

  try {
    let response = {};
    if (actionCrud === "new") {
      response = await axios({
        method: "POST",
        url: `${urlCoreBack}${epNameCaja}`,
        data: Caja,
      });
    } else if (actionCrud === "update") {
      response = await axios({
        method: "PUT",
        url: `${urlCoreBack}${epNameCaja}`,
        data: Caja,
      });
    }

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText =
          `${nameItemTextCaja}` +
          (actionCrud === "disable"
            ? itemGender === "M"
              ? " deshabilitado"
              : " deshabilitada"
            : actionCrud === "enable"
              ? itemGender === "M"
                ? " habilitado"
                : " habilitada"
              : itemGender === "M"
                ? " guardado"
                : " guardada");
        response.messageSeverity = "success";
      } else {
        // si hay error controlado
        console.log(_errorMessage);
        console.log(response);

        let _message_code = response.data.code;
        if (_message_code === "err-area-already-exist") {
          response.messageText = `Ya existe ${unUna} ${nameItemTextCaja} con esa descripción`;
        } else {
          response.messageText = _errorMessage;
        }
        response.ok = false;
        response.messageSeverity = "error";
      }
      return response;
    }
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
// iniciar caja

export const iniciarCaja = async (idCaja) => {
  let _errorMessage = `No fue posible iniciar ${elLa} ${nameItemTextCaja}`;

  try {
    const response = await axios({
      method: "POST",
      url: `${urlCoreBack}${epNameCaja}`,
      data: {
        id: idCaja,
        id_usuario: localStorage.getItem("id_usuario"),
        id_area: localStorage.getItem("id_area_ventas")
      },
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = `${nameItemTextCaja}` + " Iniciada";
        response.messageSeverity = "success";
        return response;
      }

      if (response.data.code === "err-caja-caja-revision-abierta-not-allowed") {
        response.ok = false;
        response.messageText = "No es posible abrir una caja ahora. Existe una caja Abierta o en Revisión";
        response.messageSeverity = "error";
        return response;
      }

      // si hay error controlado

      console.log(_errorMessage);
      console.log(response);

      response.messageText = _errorMessage;
      response.ok = false;
      response.messageSeverity = "error";
      return response;
    }
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
}

//
// #############################################################################
//
// borrar caja

export const borrarCaja = async (idCaja) => {


  let _errorMessage = `No fue posible borrar ${elLa} ${nameItemTextCaja}`;

  try {
    const response = await axios({
      method: "DELETE",
      url: `${urlCoreBack}${epNameCaja}`,
      params: {
        id_caja: idCaja,
        id_area: localStorage.getItem("id_area_ventas")
      },
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = `${nameItemTextCaja}` + " borrada";
        response.messageSeverity = "success";
        return response;
      }

      if (response.data.code === "err-caja-delete-not-allowed") {
        response.ok = false;
        response.messageText = "No es posible eliminar la caja. Tiene movimientos";
        response.messageSeverity = "error";
        return response;
      }

      // si hay error controlado

      console.log(_errorMessage);
      console.log(response);

      response.messageText = _errorMessage;
      response.ok = false;
      response.messageSeverity = "error";
      return response;
    }
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
}


//
// #############################################################################
//
// revisar caja 
export const revisarCaja = async (idCaja) => {
  let _errorMessage = `No fue posible Revisar ${elLa} ${nameItemTextCaja}`;
  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epNameCajaRevisar}`,
      params: {
        id: idCaja,
        id_area: localStorage.getItem("id_area_ventas"),
        id_usuario: localStorage.getItem("id_usuario")
      },
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = `${nameItemTextCaja}` + " borrada";
        response.messageSeverity = "success";
        return response;
      }

      if (response.data.code === "err-caja-caja-cerrada-not-allowed") {
        response.ok = false;
        response.messageText = "No es posible Revisar una caja cerrada";
        response.messageSeverity = "error";
        return response;
      }

      // err-caja-caja-revision-not-allowed
      if (response.data.code === "err-caja-caja-revision-not-allowed") {
        response.ok = false;
        response.messageText = "La caja ya se encuentra en estado de Revisión";
        response.messageSeverity = "error";
        return response;
      }

      // si hay error controlado

      console.log(_errorMessage);
      console.log(response);

      response.messageText = _errorMessage;
      response.ok = false;
      response.messageSeverity = "error";
      return response;
    }
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
}


export const salirRevisarCaja = async (idCaja) => {
  let _errorMessage = `No fue posible sacar de Revisión ${elLa} ${nameItemTextCaja}`;

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epNameSalirCajaRevisar}`,
      params: {
        id: idCaja,
        id_area: localStorage.getItem("id_area_ventas"),
        id_usuario: localStorage.getItem("id_usuario")
      },
    });
    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = "La " + `${nameItemTextCaja}` + " ha sido sacada de Revisión";
        response.messageSeverity = "success";
        return response;
      }

      if (response.data.code === "err-caja-caja-cerrada-not-allowed") {
        response.ok = false;
        response.messageText = "No es posible Revisar una caja cerrada";
        response.messageSeverity = "error";
        return response;
      }

      // si hay error controlado

      console.log(_errorMessage);
      console.log(response);

      response.messageText = _errorMessage;
      response.ok = false;
      response.messageSeverity = "error";
      return response;
    }
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
}

export const cerrarCaja = async (idCaja) => {
  let _errorMessage = `No fue posible Cerrar ${elLa} ${nameItemTextCaja}`;

  try {
    const response = await axios({
      method: "POST",
      url: `${urlCoreBack}${epNameCajaCerrar}`,
      data: {
        id_caja: idCaja,
        id_usuario: localStorage.getItem("id_usuario"),
        id_area: localStorage.getItem("id_area_ventas")
      },
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = `${nameItemTextCaja}` + " Cerrada";
        response.messageSeverity = "success";
        return response;
      }

      if (response.data.code === "err-caja-saldo-final-negative") {
        response.ok = false;
        response.messageText = "No es posible cerrar la caja. El saldo final es negativo";
        response.messageSeverity = "error";
        return response;
      }

      // si hay error controlado

      console.log(_errorMessage);
      console.log(response);

      response.messageText = _errorMessage;
      response.ok = false;
      response.messageSeverity = "error";
      return response;
    }
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
}
// movimientos de caja no cobranza

export const getCajaAjustes = async (params) => {
  let _params = {};
  let _errorMessage = `Se produjo un error al obtener ${nameItemsTextCajaMovimiento}`;

  if (params) {
    if (params.descripcion) {
      _params.descripcion = params.descripcion;
    }

    if (params.sumaResta) {
      _params.suma_resta = params.sumaResta;
    }

    if (params.estado) {
      let estado =
        params.estado === "habilitado"
          ? "H"
          : params.estado === "deshabilitado"
            ? "D"
            : "";
      _params.habilitado = estado;
    }

    if (params.rows) {
      _params.rows = params.rows;
    }

    if (params.first) {
      _params.first = params.first;
    }
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epNameCajaAjuste}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getCajaAjuste = async (params) => {
  let _errorMessage = `Se produjo un error al obtener ${nameItemsTextCajaMovimiento}`;

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epNameCajaAjuste}`,
      params: params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const saveCajaAjuste = async (actionCrud, item) => {
  let _errorMessage = `No fue posible guardar ${elLa} ${nameItemTextCajaMovimiento}`;

  let _item = {
    id_caja: item.idCaja,
    id_tipo_ajuste: item.idTipoAjuste,
    descripcion: item.descripcion,
    importe: item.importe,
    id_usuario: localStorage.getItem("id_usuario"),
    id_area: localStorage.getItem("id_area_ventas"),
  };
  if (actionCrud !== "new") {
    _item.id = item.id;
  }
  if (actionCrud === "delete") {
    _item.id = item.id;
    _item.motivo_anulacion = (item.motivoAnulacion).toUpperCase();
  }


  try {
    let response = {};
    if (actionCrud === "new") {
      response = await axios({
        method: "POST",
        url: `${urlCoreBack}${epNameCajaAjuste}`,
        data: _item,
      });
    } else if (actionCrud === "update") {
      response = await axios({
        method: "PUT",
        url: `${urlCoreBack}${epNameCajaAjuste}`,
        data: _item,
      });
    } else if (actionCrud === "delete") {
      response = await axios({
        method: "DELETE",
        url: `${urlCoreBack}${epNameCajaAjuste}`,
        params: {
          id: _item.id,
          id_usuario: _item.id_usuario,
          id_area: _item.id_area,
          motivo_anulacion: _item.motivo_anulacion,
        },
      });
    }

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText =
          `${nameItemTextCajaMovimiento}` +
          (actionCrud === "disable"
            ? itemGender === "M"
              ? " deshabilitado"
              : " deshabilitada"
            : actionCrud === "enable"
              ? itemGender === "M"
                ? " habilitado"
                : " habilitada"
              : itemGender === "M"
                ? " guardado"
                : " guardada");
        response.messageSeverity = "success";
      } else {
        // si hay error controlado
        console.log(_errorMessage);
        console.log(response);

        let _message_code = response.data.code;
        if (_message_code === "err-descuento-periodo-superpuesto-invalid") {
          response.messageText = `Ya se ha registrado ${unUna} ${nameItemTextCajaMovimiento} en este período con esta Descripcion`;
        } else if (_message_code === "err-descuento-fecha-vigencia-hasta-invalid") {
          response.messageText = "El período de vigencia no puede ser anterior a la fecha actual";
        } else if (_message_code === "err-descuento-fecha-vigencia-hasta-menor-hoy-not-allowed") {
          response.messageText = "La fecha final de vigencia es anterior a la fecha actual";
        } else if (_message_code === "err-caja-ajuste-estado-ajuste-not-allowed") {
          response.messageText = "No es posible guardar el ajuste ya que la caja está en estado de REVISIÓN o CERRADA";
        } else {
          response.messageText = _errorMessage;
        }
        response.ok = false;
        response.messageSeverity = "error";
      }
      return response;
    }
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};

//
// #############################################################################
//
export const saveCajaComprobante = async (actionCrud, item) => {
  let _errorMessage = `No fue posible guardar ${elLa} ${nameItemTextCajaMovimiento}`;

  let _item = {
    id_caja: item.idCaja,
    id_tipo_comprobante: item.idTipoComprobante,
    id_proveedor: item.idProveedor,
    numero_comprobante: item.numeroComprobante,
    descripcion: item.descripcion,
    importe: item.importe,
    id_usuario: localStorage.getItem("id_usuario"),
    id_area: localStorage.getItem("id_area_ventas"),
  };
  if (actionCrud !== "new") {
    _item.id = item.id;
  }
  if (actionCrud === "delete") {
    _item.id = item.id;
    _item.motivo_anulacion = (item.motivoAnulacion).toUpperCase();
  }

  try {
    let response = {};
    if (actionCrud === "new") {
      response = await axios({
        method: "POST",
        url: `${urlCoreBack}${epNameCajaComprobante}`,
        data: _item,
      });
    } else if (actionCrud === "update") {
      response = await axios({
        method: "PUT",
        url: `${urlCoreBack}${epNameCajaComprobante}`,
        data: _item,
      });
    } else if (actionCrud === "delete") {
      response = await axios({
        method: "DELETE",
        url: `${urlCoreBack}${epNameCajaComprobante}`,
        params: {
          id: _item.id,
          id_usuario: _item.id_usuario,
          id_area: _item.id_area,
          motivo_anulacion: _item.motivo_anulacion
        },
      });
    }

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText =
          `${nameItemTextCajaMovimiento}` +
          (actionCrud === "disable"
            ? itemGender === "M"
              ? " deshabilitado"
              : " deshabilitada"
            : actionCrud === "enable"
              ? itemGender === "M"
                ? " habilitado"
                : " habilitada"
              : itemGender === "M"
                ? " guardado"
                : " guardada");
        response.messageSeverity = "success";
      } else {
        // si hay error controlado
        console.log(_errorMessage);
        console.log(response);

        let _message_code = response.data.code;
        if (_message_code === "err-descuento-periodo-superpuesto-invalid") {
          response.messageText = `Ya se ha registrado ${unUna} ${nameItemTextCajaMovimiento} en este período con esta Descripción`;
        } else if (_message_code === "err-descuento-fecha-vigencia-hasta-invalid") {
          response.messageText = "El período de vigencia no puede ser anterior a la fecha actual";
        } else if (_message_code === "err-descuento-fecha-vigencia-hasta-menor-hoy-not-allowed") {
          response.messageText = "La fecha final de vigencia es anterior a la fecha actual";
        } else if (_message_code === "err-caja-comprobante-estado-comprobante-gastos-not-allowed") {
          response.messageText = "No es posible guardar el comprobante ya que la caja está en estado de REVISIÓN o CERRADA";
        }
        else {
          response.messageText = _errorMessage;
        }
        response.ok = false;
        response.messageSeverity = "error";
      }
      return response;
    }
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};

